<div>
  <app-rule-list-page detailsURL="/ruleDetails"></app-rule-list-page>
</div>
